import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import { INSTRUCTION_VISIBILITY } from '../../../../constants/aiAnalytics';
import { AI_COLORS } from '../aiAnalyticsConstants';

export default function InstructionDialog({ open, onClose, onSave, instruction, canManageGlobal = false }) {
  const isEdit = Boolean(instruction);
  const [title, setTitle] = useState('');
  const [details, setDetails] = useState('');
  const [visibility, setVisibility] = useState(INSTRUCTION_VISIBILITY.USER);

  useEffect(() => {
    if (open) {
      setTitle(instruction?.title || '');
      setDetails(instruction?.details || '');
      setVisibility(instruction?.visibility || INSTRUCTION_VISIBILITY.USER);
    }
  }, [open, instruction]);

  function handleSave() {
    const trimmed = details.trim();
    if (!trimmed) {
      return;
    }
    onSave({
      title: title.trim(),
      details: trimmed,
      visibility: canManageGlobal ? visibility : INSTRUCTION_VISIBILITY.USER
    });
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth data-testid="instruction-dialog">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {isEdit ? 'Edit Instruction' : 'New Instruction'}
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="Title"
            value={title}
            onChange={e => setTitle(e.target.value)}
            fullWidth
            size="small"
            autoFocus
          />
          <TextField
            label="Instruction"
            placeholder="What should the AI query always do?"
            value={details}
            onChange={e => setDetails(e.target.value)}
            fullWidth
            multiline
            minRows={3}
          />
          {canManageGlobal && (
            <TextField
              select
              label="Applies To"
              value={visibility}
              onChange={e => setVisibility(e.target.value)}
              fullWidth
              size="small"
              data-testid="instruction-applies-to"
            >
              <MenuItem value={INSTRUCTION_VISIBILITY.USER}>Personal (only applies to you)</MenuItem>
              <MenuItem value={INSTRUCTION_VISIBILITY.GLOBAL}>Global (applies to everyone)</MenuItem>
            </TextField>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={!details.trim()}
          sx={{ backgroundColor: AI_COLORS.brand, '&:hover': { backgroundColor: AI_COLORS.brandDark } }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
